import Restructureloan from "../../../jsx/components/Dashboard/RestructureLoan/restructureloan";

const RestructureLoanWrapper = () => {
  return <Restructureloan />;
};

export const allowedRoles = [
  _enum.ROUTE_PERSONAS.senior_underwriter,
  _enum.ROUTE_PERSONAS.underwriter,
];
export default constore(RestructureLoanWrapper);
